/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    BROADCAST_EMPTY_STATE_FIGMA_EXACT
 * Date:         2026-01-01
 * Modified By:  Cursor
 *
 * Description:
 * Implemented empty state with EXACT Figma specifications:
 * - Icon: broadcast_welcome.svg (mail/envelope with teal background)
 * - Heading: "No broadcasts at the moment" (.u-H3-22)
 * - Description: "Create a new broadcast and get matched with relevant opportunities" (.u-P1-18)
 * - Button: "Create Broadcast" with plus icon (.u-P2-16-medium)
 * - All colors use approved SCSS variables
 *
 * Figma Reference: Node 1066:6986
 *
 * File Size Check:
 * - Estimated: ~80 lines
 * - Decision: Proceed (within 200-line component limit)
 *
 * Related Screens / Modules:
 * - client/src/features/broadcast/broadcast-create/BroadcastEmptyState.tsx (NEW)
 * - client/src/features/broadcast/broadcast-create/BroadcastEmptyState.module.scss (NEW)
 * - client/src/assets/icons/broadcast_welcome.svg
 */

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import broadcastWelcomeIcon from '../../../assets/icons/broadcast_welcome.svg';
import styles from './BroadcastEmptyState.module.scss';

interface BroadcastEmptyStateProps {
  onCreateClick: () => void;
}

// [2026-01-01] Empty state: Figma-exact implementation
const BroadcastEmptyState: React.FC<BroadcastEmptyStateProps> = ({ 
  onCreateClick 
}) => {
  return (
    <div className={styles.emptyStateContainer}>
      <div className={styles.content}>
        {/* [2026-01-01] Icon: broadcast_welcome.svg from Figma */}
        <img 
          src={broadcastWelcomeIcon}
          alt="No broadcasts"
          className={styles.icon}
        />
        
        {/* [2026-01-01] Heading: Exact Figma text, H3 22 typography */}
        <h3 className="u-H3-22">
          No broadcasts at the moment
        </h3>
        
        {/* [2026-01-01] Description: Exact Figma text, P1 18 typography */}
        <p className="u-P1-18">
          Create a new broadcast and get matched with relevant opportunities
        </p>
        
        {/* [2026-01-01] Button: Exact Figma specs, P2 16 medium typography */}
        <button 
          onClick={onCreateClick}
          className={styles.createButton}
          type="button"
          aria-label="Create new broadcast"
        >
          <FontAwesomeIcon icon={faPlus} />
          <span className="u-P2-16-medium">Create Broadcast</span>
        </button>
      </div>
    </div>
  );
};

export default BroadcastEmptyState;
